<template>
  <div class="w-100 p-2 mt-2">
    <div class="row mb-2">
      <div class="col-4">
        <page-card :is-ready="!!tenant">
          <template v-slot:header>
            {{ $t('title.current_balances') }}
          </template>
          <template v-slot:content v-if="selectOptions.walletCurrency.length">
            <table class="table table-striped table-sm" :class="{'mb-4': index === 0}"  v-for="(wallet, index) in selectOptions.walletCurrency" :key="index">
              <tbody>
              <tr :class="{'quiz-coins': wallet.symbol.symbol === 'QUIZ_COINS', 'free-coins': wallet.symbol.symbol === 'FUN_COINS'}">
                <td class="font-weight-bolder">{{ $t('table.label.wallet_currency') }}</td>
                <td>{{ $t(wallet.symbol.symbol) }}</td>
              </tr>
              <tr>
                <td class="font-wei§ght-bolder">{{ $t('table.label.total_balance') }}</td>
                <td>{{ wallet.realMoneyBalanceAmount.amount | numberFormat }}</td>
              </tr>
              <tr>
                <td class="font-weight-bolder">{{ $t('table.label.locked_funds') }}</td>
                <td>{{ wallet.realMoneyLockedFoundsAmount.amount | numberFormat }}</td>
              </tr>
              <tr v-if="wallet.symbol.symbol !== 'FC'">
                <td class="font-weight-bolder">{{ $t('table.label.bonuses') }}</td>
                <td>-</td>
              </tr>
              <tr v-if="wallet.symbol.symbol !== 'FC'">
                <td class="font-weight-bolder">{{ $t('table.label.available_to_withdraw') }}</td>
                <td>-</td>
              </tr>
              </tbody>
            </table>
          </template>
        </page-card>
      </div>
      <div class="col-8">
        <page-card :is-ready="!!tenant">
          <template v-slot:header>
            {{ $t('page.filters') }}
          </template>
          <template v-slot:content>
            <div class="questions sygni-grid">
              <div class="row" v-if="selectOptions.walletCurrency.length">
                <div class="col-6">
                  <filter-select
                      :emit-event-value="true"
                      :filter-query="filterQuery"
                      :options="selectOptions.walletCurrency"
                      ref="currency-ref"
                      :multiple="false"
                      options-label="text"
                      options-track-by="value"
                      filter-name="walletCurrency"
                      :label="$t('filters.label.wallet_currency')"
                      :placeholder="$t('filters.placeholder.wallet_currency')">
                  </filter-select>
                </div>

                <div class="col-6">
                  <filter-select
                      :filter-query="filterQuery"
                      :options="selectOptions.type"
                      :multiple="false"
                      options-label="text"
                      options-track-by="value"
                      filter-name="operationType"
                      :label="$t('filters.label.operation_type')"
                      :placeholder="$t('filters.placeholder.operation_type')">
                  </filter-select>
                </div>
              </div>
              <div class="row">

                <div class="col-6">
                  <filter-input-with-operator
                      :filter-query="filterQuery"
                      :operator-options="selectOptions.comparisonOperator"
                      :operator-multiple="false"
                      :default-operator="{value: 'eq', text: 'equales'}"
                      :restrict-input="true"
                      restriction-type="numbers"
                      filter-name="operationAmount"
                      :label="$t('filters.label.operation_amount')">
                  </filter-input-with-operator>
                </div>

                <div class="col-6">
                  <filter-date-range-picker
                      :filter-query="filterQuery"
                      :locale="{firstDay: 1, format: 'yyyy-mm-dd'}"
                      :auto="true"
                      :linked="false"
                      :time-picker="true"
                      filter-name="operationCreatedAt"
                      open-direction="left"
                      :label="$t('filters.label.operation_date')">
                  </filter-date-range-picker>
                </div>
              </div>
            </div>
          </template>
          <template v-slot:footer>
            <div class="row mt-auto">
              <div class="col-12">
                <div class="float-right">
                  <b-button @click="resetFilters()" class="mr-2" variant="secondary">{{$t('filters.btn.clear')}}</b-button>
                  <b-button @click="applyFilters()" variant="primary">{{$t('filters.btn.apply')}}</b-button>
                </div>
              </div>
            </div> <!-- #card-body-->
          </template>
        </page-card>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12">
        <page-card :is-ready="!!tenant">
          <template v-slot:header>
            {{$t('title.list')}}
          </template>
          <template v-slot:content>
            <div class="sygni-grid">

              <grid-pagination :total-count="totalCount"
                               :per-page="perPage"
                               :current-page="currentPage"
                               @load-items="paginationReload"></grid-pagination>

              <div class="table-responsive">
                <b-table striped show-empty
                         :empty-text="$t('table.no_results')"
                         :busy="isBusy"
                         hover
                         head-variant="dark"
                         outlined
                         :sort-by.sync="orderColumn"
                         :sort-desc.sync="orderDirection"
                         :no-local-sorting="true"
                         :items="items"
                         :fields="fields">

                  <template #cell(operationCreatedAt)="data">
                    <div>{{ data.value | dateFormat('YYYY-MM-DD HH:mm:ss') }}</div>
                  </template>

                  <template #cell(walletBalanceAmount)="data">
                    <div>{{ data.value | numberFormat }}</div>
                  </template>

                  <template #cell(operationAmount)="data">
                    <div>{{ data.value | numberFormat }}</div>
                  </template>

                  <template #cell(id)="data">
                    <div>{{ data.value | shortId }}</div>
                  </template>
                  <template #cell(operationType)="data">
                    <div :id="data.item.id">{{ data.value }} <b-icon-info-circle-fill class="ml-2" v-if="data.item.comment"></b-icon-info-circle-fill> </div>
                    <b-tooltip v-if="data.item.comment" :target="data.item.id" triggers="hover">
                      {{data.item.comment}} <br/> created by: {{data.item.createdBy}}
                    </b-tooltip>
                  </template>

                  <template #cell(transactionId)="data">
                    <div>{{ data.value | shortId }}</div>
                  </template>


                  <template #cell(walletCurrency)="data">
                    <div>{{ $t(data.value) }}</div>
                  </template>
                  <template #cell(operationType)="data">
                    <div>{{ $t(data.value) }}</div>
                  </template>

                  <template #cell(gameId)="data">
                    <router-link
                        :to="{ name: 'game-result-list', query: { gameId: data.value }}">
                      {{ data.value | shortId }}
                    </router-link>
                  </template>

                  <template #cell(tournamentId)="data">
                    <div>
                      {{ data.value | shortId }}
                    </div>
                  </template>

                  <template #table-busy>
                    <div class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>{{$t('state.loading')}}</strong>
                    </div>
                  </template>

                </b-table>
              </div> <!-- #table-responsive-->

              <grid-pagination :total-count="totalCount"
                               :per-page="perPage"
                               :current-page="currentPage"
                               @load-items="paginationReload"></grid-pagination>
            </div>
          </template>
        </page-card>
      </div>
    </div>
  </div>
</template>

<script>
import GridMixin from "../../../components/grid/GridMixin";
import FilterSelect from "../../../components/grid/filters/FilterSelect";
import FilterInputWithOperator from "../../../components/grid/filters/FilterInputWithOperator";
import FilterDateRangePicker from "../../../components/grid/filters/FilterDateRangePicker";
import GridPagination from "../../../components/grid/grid-pagination/GridPagination";
import PageCard from "../../../components/page/PageCard";

export default {
  mixins: [GridMixin],
  components: {
    PageCard,
    GridPagination,
    FilterSelect,
    FilterInputWithOperator,
    FilterDateRangePicker
  },
  data() {
    return {
      gridGetUrl: null,
      wallets: null,
      walletCurrency: null,
      orderColumn: 'operationCreatedAt',
      fields: [
        {key: 'id', label: this.$t('table.header.operation_id')},
        {key: 'gameId', label: this.$t('table.header.game_id')},
        {key: 'tournamentId', label: this.$t('table.header.tournament_id')},
        {key: 'transactionId', label: this.$t('table.header.transaction_id')},
        {key: 'walletCurrency', label: this.$t('table.header.wallet_currency')},
        {key: 'operationType', label: this.$t('table.header.operation_type')},
        {key: 'operationAmount', label: this.$t('table.header.operation_amount'), sortable: true },
        {key: 'walletBalanceAmount', label: this.$t('table.header.available_balance_after')},
        {key: 'operationCreatedAt', label: this.$t('table.header.operation_date'), sortable: true},
      ],
      items: [],
      selectOptions: {
        walletCurrency: [

        ],
        type: [
        ],
        containOperator: [
          {value: 'eq', text: this.$t('operator.contains')},
          {value: 'neq', text: this.$t('operator.not_contains')},
        ],
        comparisonOperator: [
          {value: 'eq', text: this.$t('operator.equales')},
          {value: 'gte', text: this.$t('operator.greater_then')},
          {value: 'lte', text: this.$t('operator.lower_than')},
          {value: 'btw', text: this.$t('operator.between')},
        ]
      },
    };
  },
  mounted() {
    this.getOperationTypes();
    this.getPlatformWallet();
  },
  methods: {
    getOperationTypes() {
      this.$store.dispatch('root/getWalletDictionary')
      .then(
          data => {
            this.selectOptions.type = data['walletEntryOperationType'].map(d => {
              return {text: this.$t(d), value: d};
            });
          }
      )
    },
    getPlatformWallet() {
      this.$store.dispatch('root/getPlatformWallet').then(data => {
        const wallets = data.items;
        this.selectOptions.walletCurrency = wallets.map(w => {
          return {
            value: w.symbol.symbol,
            text: this.$t(w.symbol.symbol),
            ...w
          }
        }).reverse();
        this.getWallets();
      });
    },
    getWallets() {
      this.gridGetUrl = `/api/owner/${this.tenant.id}/wallet/history`;
      this.loadItems();
    },
    resetFilters() {
      this.filterQuery = [];
      this.$root.$emit('resetFilters');
      this.getPlatformWallet();
    },
  },
  watch: {
  },
  computed: {
    player: function () {
      return this.$store.getters["players/player"];
    },
    apiKey: function () {
      return this.$store.getters["root/apiKey"];
    },
    tenant: function () {
      return this.$store.getters['root/tenant'];
    }
  }
}
</script>
